<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ 'Chat Logs' }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text class="pa-4">
          <v-row class="mb-3">
            <v-col cols="12">
              <v-card variant="outlined" class="filter-card">
                <v-card-text class="pa-3">
                  <h4 class="section-title mb-2">
                    <v-icon class="mr-2" color="primary" size="20">mdi-calendar-range</v-icon>
                    Date Range
                  </h4>
                  <v-row class="mt-1">
                    <v-col cols="12" md="6">
                      <v-menu
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        location="bottom"
                        min-width="auto"
                      >
                        <template #activator="{ props }">
                          <v-text-field
                            v-model="filters.startDate"
                            label="Start Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            v-bind="props"
                            density="compact"
                            color="primary"
                            class="date-field"
                            clearable
                            hide-details
                          >
                            <template #append-inner>
                              <v-tooltip location="top" max-width="200">
                                <template #activator="{ props }">
                                  <v-icon size="small" color="grey-darken-1" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>Select start date for filtering</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          :model-value="filters.startDate"
                          :max="startDateMax"
                          @update:model-value="selectStartDate"
                          color="primary"
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-menu
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        location="bottom"
                        min-width="auto"
                      >
                        <template #activator="{ props }">
                          <v-text-field
                            v-model="filters.endDate"
                            label="End Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            v-bind="props"
                            density="compact"
                            color="primary"
                            class="date-field"
                            clearable
                            hide-details
                          >
                            <template #append-inner>
                              <v-tooltip location="top" max-width="200">
                                <template #activator="{ props }">
                                  <v-icon size="small" color="grey-darken-1" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>Select end date for filtering</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          :model-value="filters.endDate"
                          :min="endDateMin"
                          :max="endDateMax"
                          @update:model-value="selectEndDate"
                          color="primary"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="filters.searchTerm"
                label="Search GroupId"
                placeholder="Group Guid"
                prepend-inner-icon="mdi-identifier"
                variant="outlined"
                density="compact"
                color="primary"
                clearable
                hide-details
                @keyup.enter="submitSearch"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-btn color="primary" block :loading="loading" prepend-icon="mdi-magnify" class="search-button" @click="submitSearch">Search</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-title>
          Chats
          <v-spacer></v-spacer>
          <span class="text-caption">Total: {{ total }}</span>
        </v-card-title>
        <v-data-table-server
          class="modern-table"
          :headers="headers"
          :items="items"
          :loading="loading"
          :items-per-page="pageSize"
          :page="page"
          :items-length="total"
          @update:options="onTableOptions"
        >
          <template #item.groupId="{ item }">
            <code>{{ item.groupId }}</code>
          </template>
          <template #item.question="{ item }">
            <div class="text-content">
              {{ truncate(item.question, 80) }}
              <v-btn v-if="item.question && item.question.length > 80" icon="mdi-eye" size="small" @click="showFullQuestion(item)" class="ml-1"></v-btn>
            </div>
          </template>
          <template #item.createdDate="{ item }">
            {{ formatDateTime(item.createdDate) }}
          </template>
          <template #item.ttsErrorStatus="{ item }">
            <v-chip v-if="item.ttsErrorStatus != null" size="small" color="error" variant="flat">
              {{ item.ttsErrorStatus }}
            </v-chip>
            <span v-else class="text-caption text-grey">--</span>
          </template>
          <template #item.actions="{ item }">
            <v-btn size="small" color="primary" @click="openDetails(item.groupId)">Details</v-btn>
          </template>
        </v-data-table-server>
      </v-card>

      <v-dialog v-model="detail.show" max-width="900px" height="70vh">
        <v-card>
          <div class="" style="display: flex; flex-direction: column; height: 100%">
            <div style="flex-shrink: 0">
              <v-card-title>
                <div class="d-flex align-center" style="width: 100%">
                  <span>Group Timeline</span> <small class="ml-2">{{ detail.groupId }}</small>
                  <v-btn append-icon="mdi-refresh" color="success" variant="tonal" class="ml-auto text-none" @click="openDetails(detail.groupId)">Refresh</v-btn>
                </div>
              </v-card-title>
            </div>
            <div style="flex-grow: 1; overflow-y: auto">
              <v-card-text>
                <div v-if="detail.loading" class="text-center pa-6">
                  <v-progress-circular indeterminate color="primary" />
                </div>
                <div v-else class="timeline">
                  <div v-if="detail.timeline.length === 0" class="text-center grey--text">No logs</div>
                  <div v-else>
                    <div v-for="(row, i) in orderedTimeline" :key="i" class="timeline-item-box" :class="[
                      (row.type || 'other').toLowerCase(),
                      { 'error': row.type === 'TTS' && row.status !== 200 }
                    ]">
                      <div class="timeline-item-header">
                        <v-chip size="x-small" :color="row.type === 'GPT' ? 'deep-purple' : row.type === 'TTS' ? (row.status !== 200 ? 'red' : 'teal') : row.type === 'STT' ? 'orange' : 'indigo'" dark>
                          {{ row.type }}
                        </v-chip>
                        <span class="timestamp">{{ formatDateTime(row.createdDate) }}</span>
                        <v-chip v-if="row.timestamp != null" size="x-small" class="ml-2" color="grey-darken-3" variant="outlined">
                          {{ formatDuration(row.timestamp) }}
                        </v-chip>
                        <v-chip v-if="row.type === 'TTS' && row.status != null" size="x-small" class="ml-2" :color="row.status === 200 ? 'success' : 'error'" variant="outlined">
                          {{ row.status }}
                        </v-chip>
                        <v-spacer></v-spacer>
                        <v-btn v-if="row.type === 'TTS'" size="x-small" variant="text" icon="mdi-content-copy" @click="copyToClipboard(row.content)" title="Copy JSON"></v-btn>
                        <v-btn size="x-small" variant="text" icon="mdi-eye" @click="showFullContent(row)" :title="'View full ' + row.type + ' content'"></v-btn>
                      </div>
                      <div v-if="row.type === 'TTS'" class="timeline-item-content text-wrap json-content">
                        <pre class="json-pre">{{ formatJson(row.content) }}</pre>
                      </div>
                      <div v-else class="timeline-item-content text-wrap">
                        {{ truncate(row.content, 100) }}
                        <span v-if="row.content && row.content.length > 250" class="more-indicator">...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="detail.show = false">Close</v-btn>
              </v-card-actions>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <!-- Full Content Dialog -->
      <v-dialog v-model="fullContent.show" max-width="800px">
        <v-card>
          <v-card-title>{{ fullContent.type }} Content</v-card-title>
          <v-card-text>
            <v-card outlined class="pa-3 content-box">
              <pre class="text-wrap">{{ fullContent.text }}</pre>
            </v-card>
            <div class="mt-2 text-caption">Created: {{ formatDateTime(fullContent.created) }}</div>
            <div class="text-caption" v-if="fullContent.timestamp != null">Processing Time: {{ formatDuration(fullContent.timestamp) }}</div>
            <div class="text-caption">Type: {{ fullContent.type }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="fullContent.show = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Full Question Dialog -->
      <v-dialog v-model="fullQuestion.show" max-width="600px">
        <v-card>
          <v-card-title>Full Question</v-card-title>
          <v-card-text>
            <v-card outlined class="pa-3 content-box">
              <pre class="text-wrap">{{ fullQuestion.text }}</pre>
            </v-card>
            <div class="mt-2 text-caption">Group ID: {{ fullQuestion.groupId }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="fullQuestion.show = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {
  formatDateInput,
  getChatFullLogsInitialDateFilters,
  resolveChatFullLogsDateRange,
  shouldSearchChatFullLogsOnTableOptions,
} from '../utils/chatFullLogsDateRange.js';

export default {
  name: 'ChatFullLogs',
  inject: ['flagNav', 'FontColorTitle', 'SubNavbarBackGround'],
  data() {
    return {
      loading: false,
      flagNav: true,
      today: null,
      items: [],
      total: 0,
      page: 1,
      pageSize: 10,
      hasSearched: false,
      filters: { ...getChatFullLogsInitialDateFilters(), searchTerm: '' },
      startDateMenu: false,
      endDateMenu: false,
      headers: [
        { title: 'Group Id', value: 'groupId' },
        { title: 'Question', value: 'question' },
        { title: 'Created', value: 'createdDate' },
        { title: 'TTS', value: 'ttsErrorStatus', sortable: false },
        { title: 'Actions', value: 'actions', sortable: false },
      ],
      detail: { show: false, groupId: null, loading: false, timeline: [] },
      fullContent: { show: false, text: '', type: '', created: null, timestamp: null },
      fullQuestion: { show: false, text: '', groupId: '' },
    };
  },
  mounted() {
    this.GetDate();
  },
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('ChatFullLogs');
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('ChatFullLogs'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('ChatFullLogs'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('ChatFullLogs'),
      }
    },
    orderedTimeline() {
      return [...this.detail.timeline].sort((a, b) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime());
    },
    todayDateInput() {
      return formatDateInput(new Date());
    },
    startDateMax() {
      return this.filters.endDate || this.todayDateInput;
    },
    endDateMin() {
      return this.filters.startDate || undefined;
    },
    endDateMax() {
      return this.todayDateInput;
    },
  },
  methods: {
    GetDate() {
      const todayDate = formatDateInput(new Date());
      const [yyyy, mm, dd] = todayDate.split('-');

      this.today = `${dd}/${mm}/${yyyy}`;
    },
    selectStartDate(value) {
      this.filters.startDate = value ? formatDateInput(value) : '';
      this.startDateMenu = false;
    },
    selectEndDate(value) {
      this.filters.endDate = value ? formatDateInput(value) : '';
      this.endDateMenu = false;
    },
    onTableOptions({ page, itemsPerPage }) {
      this.page = page;
      this.pageSize = itemsPerPage;
      if (shouldSearchChatFullLogsOnTableOptions({ hasSearched: this.hasSearched })) {
        this.search();
      }
    },
    submitSearch() {
      this.hasSearched = true;
      this.page = 1;
      this.search();
    },
    search() {
      this.loading = true;
      const dateRange = resolveChatFullLogsDateRange({
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
      });

      this.filters.startDate = dateRange.startDate;
      this.filters.endDate = dateRange.endDate;

      const req = {
        startDate: dateRange.startDate || null,
        endDate: dateRange.endDate || null,
        searchTerm: this.filters.searchTerm || '',
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$call.SearchChatFullLogs(
        req,
        (res) => {
          if (res.status === 0) {
            this.items = res.data.items;
            this.total = res.data.totalCount;
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    },
    openDetails(groupId) {
      this.detail.show = true;
      this.detail.groupId = groupId;
      this.detail.loading = true;
      this.detail.timeline = [];
      this.$call.GetChatFullGroupDetails(
        groupId,
        (res) => {
          if (res.status === 0) {
            this.detail.timeline = res.data;
          }
          this.detail.loading = false;
        },
        () => {
          this.detail.loading = false;
        }
      );
    },
    showFullContent(item) {
      this.fullContent = {
        show: true,
        text: item.content || '',
        type: item.type || 'Log',
        created: item.createdDate || null,
        timestamp: item.timestamp != null ? item.timestamp : null,
      };
    },
    showFullQuestion(item) {
      this.fullQuestion = {
        show: true,
        text: item.question || '',
        groupId: item.groupId || '',
      };
    },
    formatDateTime(dt) {
      if (!dt) return '-';
      return new Date(dt + 'Z').toLocaleString();
    },
    formatDuration(milliseconds) {
      if (milliseconds == null || milliseconds < 0) return '-';
      if (milliseconds < 1000) {
        return `${milliseconds}ms`;
      } else if (milliseconds < 60000) {
        const seconds = (milliseconds / 1000).toFixed(2);
        return `${seconds}s`;
      } else {
        const minutes = Math.floor(milliseconds / 60000);
        const seconds = ((milliseconds % 60000) / 1000).toFixed(2);
        return `${minutes}m ${seconds}s`;
      }
    },
    truncate(t, n) {
      if (!t) return '';
      return t.length > n ? t.substring(0, n) + '...' : t;
    },
    formatJson(text) {
      if (!text) return '';
      try {
        const parsed = JSON.parse(text);
        return JSON.stringify(parsed, null, 2);
      } catch (e) {
        return text;
      }
    },
    copyToClipboard(text) {
      if (!text) return;
      navigator.clipboard.writeText(text).then(() => {
        // Optional: show a snackbar or toast notification
      }).catch(err => {
        console.error('Failed to copy:', err);
      });
    },
  },
};
</script>

<style scoped>
.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}
.filter-card {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.filter-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}
.date-field :deep(.v-field) {
  border-radius: 8px !important;
}
.section-title {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
  border-bottom: 2px solid rgba(25, 118, 210, 0.2);
  padding-bottom: 8px;
}
.search-button {
  min-height: 40px;
}
.page-title {
  margin: 0;
  font-weight: 600;
}
.page-description {
  margin: 0;
  color: #666;
}
.mono {
  font-family: monospace;
  white-space: pre-wrap;
}
.timeline-item-box {
  border: 1px solid #e0e0e0;
  border-left: 5px solid var(--type-color, #1976d2);
  border-radius: 6px;
  padding: 8px 12px 10px 12px;
  margin-bottom: 10px;
  background: #fafafa;
  position: relative;
}
.timeline-item-box.gpt {
  --type-color: #673ab7;
}
.timeline-item-box.tts {
  --type-color: #009688;
}
.timeline-item-box.stt {
  --type-color: #ff9800;
}
.timeline-item-box.other {
  --type-color: #455a64;
}
.timeline-item-box.error {
  --type-color: #f44336;
  border-color: #f44336;
  background: #ffebee;
}
.timeline-item-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}
.timeline-item-content {
  font-size: 0.85rem;
  line-height: 1.3rem;
  white-space: pre-wrap;
  word-break: break-word;
}
.timestamp {
  font-size: 0.7rem;
  color: #3d3d3d;
}
.more-indicator {
  color: #999;
}
.text-content {
  display: flex;
  align-items: center;
  max-width: 300px;
}
.content-box {
  background: #f5f5f5;
  max-height: 400px;
  overflow: auto;
}
.text-wrap {
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
}
.json-content {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 8px;
  max-height: 200px;
  overflow: auto;
}
.json-pre {
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.4;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
